import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, Typography} from "@mui/material"
import {IconSeeker, LoadingIconSeeker} from "@ui-seeker/core";


export default function StockAssortmentSummaryWidgetFooter({ showName, numDistinctSkus, skuScope, showSkuInfo, onClick }) {
    const loadingIcon = useSignal(false)
    const handleSubmit = e => {
        e.preventDefault()
        e.stopPropagation()
        loadingIcon.value = true
        onClick()
    }

    return <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-around'  }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: .5}} onClick={handleSubmit}>
            <IconSeeker icon={'chart-line'} sx={{ m: .5, color: 'primary.main'}}/>
            <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover": { textDecoration: 'underline'} }}>
                Show Evolution
            </Typography>
        </Box>
        { showSkuInfo && <Box sx={{ display: 'flex', alignItems: 'flex-end'}} >
            { showName && <Typography variant="subtitle2" component="div" noWrap >
                Skus:
            </Typography> }
            <Typography variant="subtitle2" sx={{ color: 'text.secondary.dark', pl: 1 }}>
                { numDistinctSkus + ' / ' + skuScope }
            </Typography>
        </Box> }
    </Box>
}